import useCourses from '@/hooks/courses/useCourses'
import { Column } from '@tanstack/react-table'
import { FilterOption } from '@/components/Table/data-table-faceted-filter'

type FilterProps<TData> = {
  column: Column<TData, unknown> | undefined
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CourseNameFilter = ({ column }: FilterProps<any>): FilterOption[] => {
  if (!column) return []

  const { data: allCourses } = useCourses()
  if (!allCourses) return []

  const uniqueTableCourses = Array.from(column.getFacetedUniqueValues().keys())
  const allCourseNames = allCourses.map((course) => course.courseName)

  const sortedUniqueValues = [...new Set([...uniqueTableCourses, ...allCourseNames])].sort()

  const options = sortedUniqueValues.map((value) => ({ value, label: value }))

  return options
}
